// src/store.js

import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './slices/User';
import responsiveReducer from './slices/Responsive';

// Configure persistence for the store
const persistConfig = {
  key: 'root',
  storage,
  // Add any non-serializable values to blacklist
  blacklist: ['register', 'rehydrate']
};

// Configure responsive persistence (we'll exclude it from persistence)
const responsivePersistConfig = {
  key: 'responsive',
  storage,
  blacklist: ['width', 'height', 'isMobile', 'isTablet', 'isDesktop', 'isResponsiveMode'] // We don't want to persist screen size data
};

// Persisted reducers
const persistedUserReducer = persistReducer(persistConfig, userReducer);
const persistedResponsiveReducer = persistReducer(responsivePersistConfig, responsiveReducer);

export const store = configureStore({
  reducer: {
    user: persistedUserReducer,
    responsive: persistedResponsiveReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['register', 'rehydrate'],
        // Ignore these paths in the state
        ignoredPaths: ['register', 'rehydrate'],
      },
    }),
});

export const persistor = persistStore(store);
